import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].GET_PHOTOS]: {
		url:'/company/:companyId/infrastructure/:infrastructureId/photos/',
	},
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].GET_PHOTO]: {
		url: '/company/:companyId/infrastructure/:infrastructureId/photos/:photosId/',
	},
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].CREATE_PHOTO]: {
		url:'/company/:companyId/infrastructure/:infrastructureId/photos/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].PATCH_PHOTO]: {
		url: '/company/:companyId/infrastructure/:infrastructureId/photos/:photosId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].PUT_PHOTO]: {
		url: '/company/:companyId/infrastructure/:infrastructureId/photos/:photosId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_PHOTOS].DELETE_PHOTO]: {
		url: '/company/:companyId/infrastructure/:infrastructureId/photos/:photosId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}